export default {
  props: {
    // 栏目标题
    title: {
      default: '',
      type: String,
    },
    // 栏目介绍
    describe: {
      default: '',
      type: String,
    },
    // 着重符号
    emphasis: {
      default: '2',
      type: String,
    },
    // 着重符号颜色
    dotColor: {
      default: '#000000',
      type: String,
    },
    // 样式类型
    styleType: {
      default: '1',
      type: [String, Number],
    },
    buttonName: {
      default: '',
      type: String,
    },
    buttonUrl: {
      default: '',
      type: String,
    },
    radiusType: {
      default: 'rounded',
      type: String,
    },
    fontFamily: {
      default: '',
      type: String,
    },
  },
}
